import React from 'react';
import { DraggableContainer } from '@/features/DraggableContainer/DraggableContainer';
import { useDraggableContainer } from '@/features/DraggableContainer/hooks/useDraggableContainer';

interface DraggableContainerWrapperProps {
  children: React.ReactNode;
  className?: string;
}

export const DraggableContainerWrapper: React.FC<
  DraggableContainerWrapperProps
> = ({ children, className }) => {
  const {
    containerClassName,
    showLeftButton,
    showRightButton,
    onScrollLeft,
    onScrollRight,
    onScroll,
    scrollRef,
    contentRef,
  } = useDraggableContainer(className, children);

  return (
    <DraggableContainer
      containerClassName={containerClassName}
      showLeftButton={showLeftButton}
      showRightButton={showRightButton}
      onScrollLeft={onScrollLeft}
      onScrollRight={onScrollRight}
      onScroll={onScroll}
      scrollRef={scrollRef}
      contentRef={contentRef}
    >
      {children}
    </DraggableContainer>
  );
};
